const initCuratedCollections = (root = document) => {
  root.querySelectorAll('[data-curated-collections]').forEach((shell) => {
    if (shell.dataset.curatedCollectionsBound === 'true') return;

    const track = shell.querySelector('[data-curated-collections-track]');
    const prevButton = shell.querySelector('[data-curated-collections-prev]');
    const nextButton = shell.querySelector('[data-curated-collections-next]');

    if (!track || !prevButton || !nextButton) return;

    shell.dataset.curatedCollectionsBound = 'true';

    const getStep = () => Math.max(track.clientWidth * 0.72, 240);

    const updateButtons = () => {
      const maxScrollLeft = track.scrollWidth - track.clientWidth;
      const hasOverflow = maxScrollLeft > 4;

      shell.classList.toggle('collections-list-curated-shell--has-overflow', hasOverflow);
      prevButton.hidden = !hasOverflow;
      nextButton.hidden = !hasOverflow;

      if (!hasOverflow) {
        prevButton.disabled = true;
        nextButton.disabled = true;
        return;
      }

      prevButton.disabled = track.scrollLeft <= 4;
      nextButton.disabled = track.scrollLeft >= maxScrollLeft - 4;
    };

    prevButton.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    nextButton.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initCuratedCollections());
} else {
  initCuratedCollections();
}

document.addEventListener('shopify:section:load', (event) => {
  initCuratedCollections(event.target);
});
